import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api/axios';

export default function MerdekaDownload() {
  const [title, setTitle] = useState('');
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    api.get('/materi/9/info')
      .then(res => {
        if (cancelled) return;
        const t = res.data.title || 'Ebook';
        setTitle(t);
        // trigger download after title fetched so notification shows correct name
        window.location.href = '/materi/9/download';
      })
      .catch(() => {
        if (cancelled) return;
        setError('Gagal memuat info ebook.');
        // still trigger download even if info fails
        window.location.href = '/materi/9/download';
      });
    return () => { cancelled = true; };
  }, []);

  return (
    <div className="container py-5 text-center">
      <div className="alert alert-success mx-auto" style={{ maxWidth: 600 }}>
        <h5 className="alert-heading"><i className="bi bi-check-circle-fill me-2"></i>Download dimulai!</h5>
        {title ? (
          <p className="mb-1">Ebook <strong>{title}</strong> sudah di-download.</p>
        ) : error ? (
          <p className="mb-1">{error} — file tetap di-download.</p>
        ) : (
          <p className="mb-1">Ebook sedang di-download…</p>
        )}
        <p className="mb-0 small text-muted">Jika download tidak otomatis, <a href="/materi/9/download">klik di sini</a>.</p>
      </div>
      <Link to="/promo-merdeka" className="btn btn-outline-secondary mt-3">Lihat Promo Merdeka</Link>
    </div>
  );
}
